










































































import { Component, Vue } from 'vue-property-decorator';
import { 卸型 } from '@/type/wholesale/wholesale';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import moment from 'moment';
import { loginModule } from '@/store/authentication/login';

import { progress } from '@/script/progress';

import { ValidationResult } from '@/type/validation/result';
import { 発注確認書出力条件型, 発注確認書並び順区分型, 発注確認書出力条件バリデータ一覧 } from '@/type/purchaseorder/report';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import Timepicker from '@/components/datepicker/TimePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    Timepicker,
    SenderSelector,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
  },
})

export default class PrintOrderConfirmation extends Vue {
  private アラートメッセージ: string | string[] | null = null;
  private 発注確認書出力条件: 発注確認書出力条件型 | null = null;

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(発注確認書出力条件バリデータ一覧);

  private created(): void {
    this.initialize();
  }

  private initialize() {
    this.発注確認書出力条件 = {
      利用者コード: null,
      卸コード: null,
      発注入力方法区分: null,
      発注日開始日付: moment().toDate(),
      発注日終了日付: null,
      並び順区分: 発注確認書並び順区分型.指定なし,
    };

    if (!loginModule.管理者である) {
      this.発注確認書出力条件.利用者コード = loginModule.利用者コードを取得する;
    }
  }

  private beforeUpdate(): void {
    this.検索条件バリデーション結果.validate(this.発注確認書出力条件);
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private 印刷ダイアログを開く(): void {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('印刷ダイアログ');
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private APIアラートダイアログを開く(data: any) {
      this.アラートメッセージ = [data.message];
      if (data.errors !== null && data.errors !== undefined) {
        for (const エラー of data.errors) {
          this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
        }
      }
      this.$modal.show('アラート');
  }

  private async 発注確認書帳票出力ハンドラ(): Promise<void> {
    await progress(this.発注確認書帳票出力をする);
  }

  private async 発注確認書帳票出力をする(): Promise<void> {
    if (!this.発注確認書出力条件) { return; }
    const ファイル名: string = '発注確認書_' + moment().format('YYYYMMDDhhmmss') + '.pdf';
    download.対象の発注確認書帳票を出力する(ファイル名, this.発注確認書出力条件)
        .catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
        });
    this.ダイアログを閉じる('印刷ダイアログ');
  }
}
